export default __webpack_public_path__ + "static/smooth-494bc92f275061db5c87862a4f9535b3.png";